@if (!currentState) {
<span>Cargando...</span>
} @else {
<app-logo-header></app-logo-header>

<div class="py-4">
  <app-step-indicator [stepData]="stepData"></app-step-indicator>
</div>

<section class="space-y-4" role="main" aria-labelledby="phone-title">
  <h1
    id="phone-title"
    class="text-gray-700 text-base font-medium fs-condensed leading-tight"
  >
    Agrega tu número de teléfono a tu cuenta digital
  </h1>

  <div class="space-y-3">
    <div class="flex space-x-3">
      <ng-container *ngTemplateOutlet="countrySelector"></ng-container>
      <ng-container *ngTemplateOutlet="phoneInput"></ng-container>
    </div>
  </div>

  <p
    id="phoneInfo"
    class="text-xs text-gray-500 mt-1 underline opacity-80 mb-4"
  >
    Ingresa tu número sin espacios ni guiones
  </p>
  <ng-container *ngTemplateOutlet="sendOtpButton"></ng-container>

  @if (otpSent()) {
  <div class="pt-6">
    <app-otp-block
      [length]="4"
      [instructionText]="
        'Hemos enviado un código de 4 dígitos al número que tienes registrado. Escríbelo a continuación para continuar con tu perfil.'
      "
      [resendTimer]="countdown()"
      (onResendCode)="sendOtp()"
      (onSubmit)="crearCuenta($event)"
      submitLabel="CREAR CUENTA"
      [withResendButton]="true"
      [isLoading]="isLoading()"
    >
      <span slot="bottom-text" class="text-xs text-center text-gray-500">
        Al hacer click en <span class="font-semibold">Crear cuenta</span>,
        aceptas los
        <a
          href="https://www.allasrepuestos.com/privacidad.html"
          target="_blank"
          rel="noopener noreferrer"
          class="text-appPrimary-500 hover:text-appPrimary-600 transition-colors"
          >Términos y Condiciones</a
        >, y nuestra
        <a
          href="https://www.allasrepuestos.com/privacidad.html"
          target="_blank"
          rel="noopener noreferrer"
          class="text-appPrimary-500 hover:text-appPrimary-600 transition-colors"
          >Política de Privacidad</a
        >.
      </span>
    </app-otp-block>
    <div class="mx-auto mt-4 w-fit">
      <button
        type="button"
        class="text-sm text-appPrimary-500 hover:text-appPrimary-600 transition-colors w-fit"
        (click)="cambiarNumero()"
        aria-label="Cambiar número"
      >
        Cambiar número
      </button>
    </div>
  </div>
  }
</section>

<ng-template #countrySelector>
  <div class="relative flex-1">
    <button
      type="button"
      class="w-full px-3 py-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-appPrimary-500 focus:border-transparent text-left bg-white"
      (click)="toggleCountrySelector()"
      [disabled]="otpSent() || isLoading()"
      [attr.aria-expanded]="showCountrySelector"
      aria-haspopup="listbox"
      aria-label="Seleccionar país"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-2">
          <img
            alt="Bandera de {{ selectedCountry.nombre }}"
            [src]="selectedCountry.bandera"
            [alt]="selectedCountry.nombre"
            loading="lazy"
            class="w-5 h-4 object-cover rounded"
          />
          <span class="text-gray-500 text-sm">
            {{ selectedCountry.telefonos[0] }}
          </span>
        </div>
        <ng-container *ngTemplateOutlet="dropdownArrow"></ng-container>
      </div>
    </button>

    @if (showCountrySelector) {
    <div
      class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-40 overflow-y-auto"
      role="listbox"
      aria-label="Lista de países"
    >
      @for (country of countries; track trackByCountryCode(country)) {
      <ng-container>
        <button
          type="button"
          class="w-full px-3 py-2 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none text-sm"
          (click)="selectCountry(country)"
          [disabled]="otpSent() || isLoading()"
          role="option"
          [attr.aria-selected]="country.codigo === selectedCountry.codigo"
        >
          <div class="flex items-center space-x-2">
            <img
              alt="Bandera de {{ country.nombre }}"
              [src]="country.bandera"
              [alt]="country.nombre"
              loading="lazy"
              class="w-5 h-4 object-cover rounded"
            />
            <span class="text-gray-500">{{ country.telefonos[0] }}</span>
          </div>
        </button>
      </ng-container>
      }
    </div>
    }
  </div>
</ng-template>

<ng-template #dropdownArrow>
  <svg
    class="w-4 h-4 text-gray-400"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M19 9l-7 7-7-7"
    ></path>
  </svg>
</ng-template>

<ng-template #sendOtpButton>
  <button
    type="button"
    class="w-full py-4 rounded-lg font-medium text-base transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2"
    [class.bg-allasRed]="isPhoneValid"
    [class.text-white]="isPhoneValid"
    [class.hover:bg-allasRed-500]="isPhoneValid"
    [class.focus:ring-allasRed-500]="isPhoneValid"
    [class.bg-gray-300]="!isPhoneValid || otpSent() || isLoading()"
    [class.text-gray-500]="!isPhoneValid || otpSent() || isLoading()"
    [class.cursor-not-allowed]="!isPhoneValid || otpSent() || isLoading()"
    [disabled]="!isPhoneValid || otpSent() || isLoading()"
    (click)="sendOtp()"
    aria-describedby="otp-button-help"
  >
    ENVIAR CÓDIGO DE VERIFICACIÓN
  </button>
  <div id="otp-button-help" class="sr-only">
    {{
      isPhoneValid
        ? "Enviar código de verificación"
        : "Completa el número de teléfono"
    }}
  </div>
</ng-template>

<ng-template #phoneInput>
  <div class="flex-2">
    <input
      type="tel"
      inputmode="numeric"
      [ngModel]="numeroTelefono"
      (input)="onPhoneInput($event)"
      [disabled]="isLoading() || otpSent()"
      placeholder="99999999"
      class="w-full px-3 py-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-appPrimary-500 focus:border-transparent text-gray-700 text-sm"
      maxlength="20"
      pattern="\d{8}"
      aria-label="Número de teléfono"
      aria-describedby="phone-help"
    />
    <div id="phone-help" class="sr-only">Ingresa tu número de teléfono</div>
  </div>
  <div id="otp-button-error" class="text-red-500 text-xs font-medium">
    {{ error?.message }}
  </div>
</ng-template>
}
